import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import { Fragment } from "react";
import Select from "react-select";
import Form from "react-bootstrap/Form";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Button } from "react-bootstrap";

const ROOT_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000"
    : "https://ezice.herokuapp.com";

const options = [
  { value: 0, label: "Input the minimum dimension I want" },
  { value: 1, label: "Input the maximum dimensions I can fit" },
  {
    value: 2,
    label: "Input my EZ ICE Rink Size so I can use my rink with synthetic ice",
  },
  { value: 3, label: "Manually select how many panels I want" },
];

const customStyles = {
  option: (styles) => ({
    ...styles,
    cursor: "pointer",
  }),
  control: (styles) => ({
    ...styles,
    cursor: "pointer",
    // width: "520px",
  }),
};

function SynIceCalc(props) {
  const [selectionIndex, setSelectionIndex] = useState(null);
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const [numIcePanels, setNumIcePanels] = useState(0);
  const [rinkWidth, setRinkWidth] = useState(0);
  const [rinkLength, setRinkLength] = useState(0);
  const [skatingWidth, setSkatingWidth] = useState(0);
  const [skatingLength, setSkatingLength] = useState(0);
  const [orderNumber, setOrderNumber] = useState("");
  const [lastName, setLastName] = useState("");
  const [displayOrderNumberInput, setDisplayOrderNumberInput] = useState(false);
  const [cartIndex, setCartIndex] = useState(
    parseInt(new URLSearchParams(window.location.search).get("i") || 0)
  );

  useEffect(() => {
    if (rinkWidth > 0 && rinkLength > 0) {
      let widthPanels;
      let lengthPanels;

      if (selectionIndex === 0) {
        widthPanels = Math.ceil(rinkWidth / 4);
        lengthPanels = Math.ceil(rinkLength / 4);
      } else if (selectionIndex === 1) {
        widthPanels = Math.floor(rinkWidth / 4);
        lengthPanels = Math.floor(rinkLength / 4);
      } else if (selectionIndex === 2) {
        widthPanels = Math.ceil((rinkWidth + 2.67) / 4);
        lengthPanels = Math.ceil((rinkLength + 2.67) / 4);
      } else {
        throw new Error("Invalid selection index");
      }

      setNumIcePanels(widthPanels * lengthPanels);
      setSkatingWidth(widthPanels * 4);
      setSkatingLength(lengthPanels * 4);
    }
  }, [rinkWidth, rinkLength, selectionIndex]);

  function initializeCartIndex() {
    const params = new URLSearchParams(window.location.search);

    const cartIdx = parseInt(params.get("i"));
    const cartLength = parseInt(params.get("l"));

    if (cartIdx === -1) {
      setCartIndex(cartLength);
    } else {
      setCartIndex(cartIdx);
    }
  }

  function handleSetSelectionIndex(idx) {
    idx = parseInt(idx);
    if (idx === -1) {
      setSelectionIndex(null);
    }

    setRinkWidth(0);
    setRinkLength(0);
    setNumIcePanels(0);

    setSelectionIndex(idx);
  }

  async function getCurrentRink(idx) {
    const resp = await axios.post(`${ROOT_URL}/api/orders/current_rink`, {
      order_number: orderNumber,
      last_name: lastName,
    });

    if (resp.data.width && resp.data.length) {
      setRinkWidth(resp.data.width);
      setRinkLength(resp.data.length);

      setDisplayOrderNumberInput(false);
    } else {
      toast.error("Incorrect Last Name or Order Number.");
    }
  }

  function renderRinkInputs() {
    return (
      <Fragment>
        <div className="flex flex-col mt-4">
          <div className="flex items-center">
            <Form.Control
              className="w-[100px]"
              type="number"
              value={rinkWidth}
              onChange={(selection) =>
                setRinkWidth(Math.ceil(parseFloat(selection.target.value)))
              }
            />
            <div className="flex inline-block mx-2 mr-4">Feet</div>
            <Form.Control
              className="w-[100px]"
              type="number"
              value={rinkLength}
              onChange={(selection) =>
                setRinkLength(Math.ceil(parseFloat(selection.target.value)))
              }
            />
            <div className="flex inline-block mx-2">Feet</div>
          </div>
          <div className="flex">
            <div className="ml-[30px]">Width</div>
            <div className="ml-[115px]">Length</div>
          </div>
        </div>
      </Fragment>
    );
  }

  function postMessage(message) {
    console.log("Posting message", JSON.stringify(message));
    window.parent.postMessage(message, "*");
  }

  async function addToCart() {
    setIsAddingToCart(true);

    postMessage(
      {
        messageType: "upsertCart",
        payload: {
          updates: {
            40325017960551: numIcePanels,
          },
        },
      },
      "*"
    );

    setIsAddingToCart(false);
    toast.success("Added to cart!");
  }

  function renderOrderNumberInput() {
    return (
      <Fragment>
        <div className="flex flex-col mt-4">
          <div>Order Number</div>
          <Form.Control
            className="w-32 px-2"
            value={orderNumber}
            onChange={(e) => setOrderNumber(e.target.value)}
            onKeyDown={(event) => event.key === "Enter" && getCurrentRink()}
          />
        </div>
        <div className="flex flex-col">
          <div>Last Name</div>
          <Form.Control
            className="w-32 px-2"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            onKeyDown={(event) => event.key === "Enter" && getCurrentRink()}
          />
        </div>

        <Button
          className="hover:bg-ezice-blue-800 p-2 text-lg w-28 font-bold text-white bg-ezice-blue-600 flex justify-center items-center mt-4"
          onClick={getCurrentRink}
        >
          Submit
        </Button>
      </Fragment>
    );
  }

  return (
    <div className="flex flex-col items-left">
      <div className="">
        <div className="text-ezice-red-600 font-bold text-2xl">STEP 2:</div>
        <div className="text-ezice-red-600 text-xl">
          Synthetic Ice Skating Surface
        </div>
        <div className="text-ezice-red-600 font-bold">&nbsp;</div>
      </div>
      <hr />
      <div className="flex flex-col">
        <div className="flex flex-col" id="dropdown-container">
          <div className="text-2xl bk5:text-xl font-bold">
            Synthetic Ice Calculator
          </div>
          <div className="text-md">
            Floor panels only. Prices do not include a matching rink.
          </div>
          <div className="mt-4">
            <div className="mb-2">I want to: </div>
            <select
              id="syn-ice-type"
              className="w-full mt-1 p-2 bg-white border-[#CED4DA] border rounded-md cursor-pointer"
              onChange={(e) => handleSetSelectionIndex(e.target.value)}
            >
              <option value="-1">Select...</option>
              <option value="0">Input the minimum dimension I want</option>
              <option value="1">Input the maximum dimensions I can fit</option>
              <option value="2">
                Input my EZ ICE Rink Size so I can use my rink with synthetic
                ice
              </option>
              <option value="3">Manually select how many panels I want</option>
            </select>
          </div>
        </div>
        <div id="input-container" className="mt-2">
          <div className="">
            {selectionIndex === 0 && (
              <Fragment>
                <div>Input the MINIMUM size skating surface that you want.</div>
                {renderRinkInputs()}
              </Fragment>
            )}
            {selectionIndex === 1 && (
              <Fragment>
                <div>Input the MAXIMUM size skating surface that you want.</div>
                {renderRinkInputs()}
              </Fragment>
            )}
            {selectionIndex === 2 && (
              <Fragment>
                {!displayOrderNumberInput && (
                  <Fragment>
                    <div>
                      Input your current EZ ICE Rinks size. Click{" "}
                      <a
                        className="cursor-pointer"
                        onClick={() => setDisplayOrderNumberInput(true)}
                      >
                        here
                      </a>{" "}
                      to look up by order number.
                    </div>
                    {renderRinkInputs()}
                  </Fragment>
                )}

                {displayOrderNumberInput && (
                  <Fragment>
                    <div>
                      Input your EZ ICE Rinks order. Click{" "}
                      <a
                        className="cursor-pointer"
                        onClick={() => setDisplayOrderNumberInput(false)}
                      >
                        here
                      </a>{" "}
                      to manually input rink dimensions.
                    </div>
                    {renderOrderNumberInput()}
                  </Fragment>
                )}
              </Fragment>
            )}
            {selectionIndex === 3 && (
              <Fragment>
                <div>How many synthetic ice panels would you like?</div>
                <Form.Control
                  className="w-[100px] mt-2"
                  type="number"
                  value={numIcePanels}
                  onChange={(selection) =>
                    setNumIcePanels(selection.target.value)
                  }
                />
              </Fragment>
            )}

            <div className="absolute p-2 font-bold bottom-0 bk8:text-sm">
              Synthetic Ice can only be installed on a hard, flat and level
              surface. Looking to create a base to install Synthetic Ice on?
              Contact us, below!
            </div>
          </div>
          {((selectionIndex < 3 && rinkWidth > 0 && rinkLength > 0) ||
            (selectionIndex === 3 && numIcePanels > 0)) && (
            <div id="results-container" className="mt-4">
              <h5 className="mb-4">Result:</h5>
              <div>
                <div className="mb-1">
                  <b>QTY {numIcePanels}</b>, 4'x4' Synthetic Ice Panels
                </div>
                {selectionIndex < 3 && (
                  <Fragment>
                    <div className="mb-1">
                      <b>Actual Synthetic Ice Dimensions</b>: {skatingWidth}'x
                      {skatingLength}'
                    </div>
                  </Fragment>
                )}

                {selectionIndex === 3 && (
                  <Fragment>
                    <div className="mb-1">
                      <b>Total Skating Area</b>: {numIcePanels * 16} sq. ft
                    </div>
                  </Fragment>
                )}

                {/* <div className="mb-1">
                  <b>Sub Total</b>: $
                  {(numIcePanels * 168).toFixed(2).toLocaleString()}
                </div>

                <div className="mb-4">
                  <b>Discount</b>: $
                  {(numIcePanels * 168 * 0.15).toFixed(2).toLocaleString()} (15%
                  Applied at checkout)
                </div> */}

                <div className="mb-1">
                  <b>Total</b>: $
                  {(numIcePanels * 168).toFixed(2).toLocaleString()}
                </div>
                <Button
                  className="mt-4 bg-[#2C70B3] hover:bg-ezice-blue-800 p-2 text-lg w-40 font-bold text-white rounded-xl"
                  onClick={addToCart}
                >
                  {isAddingToCart
                    ? "Adding to Cart..."
                    : cartIndex === -1
                    ? "Add to Cart"
                    : "Update Cart"}
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SynIceCalc;
